export const HEADER_CONSTANTS = {
  beforeEvent: 'Live In ',
  live: 'We Are Live Now!!',
  afterEvent: 'See You In 2023!',
  days: 'd',
  hours: 'h',
  minutes: 'm',
  seconds: 's',
};

export const TIMER_STATE = {
  live: 'live',
  beforeEvent: 'beforeEvent',
  afterEvent: 'afterEvent',
};
